import { render, staticRenderFns } from "./mc-summary.vue?vue&type=template&id=2534b2c7&scoped=true"
import script from "./mc-summary.vue?vue&type=script&lang=ts"
export * from "./mc-summary.vue?vue&type=script&lang=ts"
import style0 from "./mc-summary.vue?vue&type=style&index=0&id=2534b2c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534b2c7",
  null
  
)

export default component.exports